/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Compte bancaire tel qu'exposé dans les blocs assureur.
 * @export
 * @interface CompteBancaireLightDto
 */
export interface CompteBancaireLightDto {
    /**
     * 
     * @type {string}
     * @memberof CompteBancaireLightDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompteBancaireLightDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompteBancaireLightDto
     */
    iban?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CompteBancaireLightDto
     */
    isDefault?: boolean;
}

/**
 * Check if a given object implements the CompteBancaireLightDto interface.
 */
export function instanceOfCompteBancaireLightDto(value: object): value is CompteBancaireLightDto {
    return true;
}

export function CompteBancaireLightDtoFromJSON(json: any): CompteBancaireLightDto {
    return CompteBancaireLightDtoFromJSONTyped(json, false);
}

export function CompteBancaireLightDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompteBancaireLightDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'libelle': json['libelle'] == null ? undefined : json['libelle'],
        'iban': json['iban'] == null ? undefined : json['iban'],
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
    };
}

export function CompteBancaireLightDtoToJSON(json: any): CompteBancaireLightDto {
    return CompteBancaireLightDtoToJSONTyped(json, false);
}

export function CompteBancaireLightDtoToJSONTyped(value?: CompteBancaireLightDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'libelle': value['libelle'],
        'iban': value['iban'],
        'isDefault': value['isDefault'],
    };
}

